import React from 'react';
import CTAButton from './common/CTAButton';

function Hero() {
  return (
    <section className="relative text-center py-16 md:py-24 lg:py-32 bg-white overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 md:mb-6 leading-tight text-primary">Stop Chasing Payments. Start Getting Paid.</h1>
        <p className="text-lg sm:text-xl md:text-2xl mb-6 md:mb-10 max-w-3xl mx-auto text-primary-light">Simple, automated payment reminders for freelancers and small service businesses who invoice manually. Set it up once, we handle the rest.</p>
        
        {/* Social Proof - made more compact on mobile */}
        <p className="text-sm text-accent font-medium mb-6 md:mb-8">Loved by 20+ early users 💙 Join 30 others waiting for launch</p>
        
        {/* Link the button to the CTA section */}
        <CTAButton href="#cta" text="Get Early Access" primary={false} />

        {/* Real Dashboard Image */}
        <div className="mt-12 md:mt-16 lg:mt-24 max-w-4xl mx-auto">
          <div className="rounded-lg shadow-xl border border-gray-200 overflow-hidden">
            <img 
              src="/images/dash1.png" 
              alt="PolitePay Dashboard" 
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero; 